<template>
  <div class="c-audience">
    <Spin size="large" fix v-if="loading" />
    <Row :gutter="12">
      <Col span="17">
        <Row>
          <Col span="7" class-name="c-group-box m-box m-wrap">
            <div class="c-header"><span>账号</span></div>
            <div class="c-content">
              <div v-for="item in accounts" :key="item.id" :class="itemClasses(item)" @click.stop="$emit('on-current', item.id)">
                <div class="c-item">
                  <span
                    >{{ item.name }} <ins style="color: #ff9900" v-show="Boolean(count(item.id))">({{ count(item.id) }})</ins></span
                  >
                  <Icon type="ios-arrow-forward" class="c-check-arrow" size="14" color="#c1c1c1" />
                </div>
              </div>
            </div>
          </Col>
          <Col span="17" class-name="c-group-box m-box m-wrap" v-if="len">
            <div class="c-header">
              <span>人群包</span>
              <span class="tag-title tag-icon"
                >排除

                <Icon
                  v-if="attrSelectAll('exclude')"
                  type="ios-checkbox"
                  color="#2d8cf0"
                  :size="16"
                  @click="$emit('on-select-all', { type: 'excludes', check: false, account: current, checkList: drops })" />

                <Icon
                  v-else
                  type="ios-square-outline"
                  color="#dcdee2"
                  :size="16"
                  @click="$emit('on-select-all', { type: 'excludes', check: true, account: current, checkList: drops })"
              /></span>
              <span class="tag-title tag-icon"
                >定向

                <Icon
                  v-if="attrSelectAll('include')"
                  type="ios-checkbox"
                  color="#2d8cf0"
                  :size="16"
                  @click="$emit('on-select-all', { type: 'includes', check: false, account: current, checkList: drops })" />

                <Icon
                  v-else
                  type="ios-square-outline"
                  color="#dcdee2"
                  :size="16"
                  @click="$emit('on-select-all', { type: 'includes', check: true, account: current, checkList: drops })"
              /></span>
              <span class="tag-title">{{ attribe }}</span>
              <span class="tag-title">ID</span>
            </div>
            <div class="c-search">
              <Input v-model="keyword" suffix="ios-search" placeholder="请输入关键词" />
            </div>
            <div class="c-content">
              <div class="c-check-item g-clearfix" v-for="item in drops" :key="item.id">
                <span class="m-span">{{ item.name }}</span>
                <span class="item-type">{{ item.id }}</span>
                <span class="item-type">{{ attriVal(item) }}</span>
                <RadioGroup v-model="item.select" style="width: 64px; float: right; line-height: 36px">
                  <Radio label="include"></Radio>
                  <Radio label="exclude" :disabled="item.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY'"></Radio>
                </RadioGroup>
                <span class="m-cataract c-include" @click.stop="$emit('on-select', { item, account: current, type: 'include' })"></span>
                <span v-if="item.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY'" class="m-cataract c-exclude c-disabled"></span>
                <span
                  v-else
                  class="m-cataract c-exclude"
                  @click.stop="$emit('on-select', { item, account: current, type: 'exclude' })"
                ></span>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col span="6" offset="1" v-if="Boolean(extend)">
        <div class="m-wrap">
          <div class="m-box c-result-box">
            <span class="c-retarget-clear" @click="$emit('on-clear', { account: current })">清空全部</span>
            <Tabs v-model="currenTab" size="small">
              <TabPane :label="`定向${includes.length ? '(' + includes.length + ')' : ''}`" class="c-retarget-result" name="include">
                <div v-for="item in includes" :key="item.id" class="c-pop-tip">
                  <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
                </div>
              </TabPane>
              <TabPane :label="`排除${excludes.length ? '(' + excludes.length + ')' : ''}`" class="c-retarget-result" name="exclude">
                <div v-for="item in excludes" :key="item.id" class="c-pop-tip">
                  <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray, trim } from '@/common/js/utils'
import { toCountCrowd } from '@/common/js/filters'
export default {
  name: 'audience',
  props: {
    value: {
      type: String
    },
    loading: {
      type: Boolean
    },
    current: {
      type: Number
    },
    accounts: {
      type: Array
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    media: {
      type: Number
    },
    audience: {
      type: Array,
      default() {
        return []
      }
    },
    deliveryMode: {
      type: String
    }
  },
  computed: {
    currenTab: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    drops() {
      return this.audience.filter((ret) => {
        const keyword = trim(this.keyword)
        if (keyword) return ret.name.includes(keyword)
        else {
          return true
        }
      })
    },
    itemClasses() {
      return (item) => {
        const cls = ['m-account']
        item.id === this.current && cls.push('active')
        return cls
      }
    },
    includes() {
      const data = []
      const currentData = this.data.filter((ret) => ret.id === this.current).pop()
      if (currentData) {
        let { includes } = currentData
        includes = includes.filter((ret) => ret && ret.id)
        data.push(...includes)
      }
      return data
    },
    excludes() {
      const data = []
      const currentData = this.data.filter((ret) => ret.id === this.current).pop()
      if (currentData) {
        let { excludes } = currentData
        excludes = excludes.filter((ret) => ret && ret.id)
        data.push(...excludes)
      }
      return data
    },
    extend() {
      return this.current && (this.includes.length || this.excludes.length)
    },
    count() {
      return (account) => {
        let num = 0
        const item = this.data.filter((ret) => ret.id === account)
        if (item.length) {
          const { includes, excludes } = item
          isArray(includes) && (num += includes.length)
          isArray(excludes) && (num += excludes.length)
        }
        return num
      }
    },
    len() {
      return isArray(this.audience) && this.audience.length
    },
    attribe() {
      if (this.media === 16) return '覆盖数量'
      else return '属性'
    },
    attriVal() {
      return (item) => {
        if (this.media === 16) return toCountCrowd(item.count)
        else return item.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY' ? '第三方' : '自定义'
      }
    },
    attrSelectAll() {
      return (select) => {
        const bool = isArray(this.drops) && this.drops.length
        if (select === 'exclude') {
          return (
            bool && this.drops.filter((ret) => ret.source !== 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY').every((ret) => ret.select === 'exclude')
          )
        } else if (select === 'include') return bool && this.drops.every((ret) => ret.select === 'include')
      }
    }
  },
  methods: {
    handleClose(event, name) {
      this.$emit('on-delete', { item: name, account: this.current, type: this.currenTab })
    }
  },
  data() {
    return {
      keyword: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-audience {
  position: relative;

  .m-wrap {
    border-bottom: 1px solid #e8eaec;
    border-right: 1px solid #e8eaec;
  }

  .m-box {
    border-top: 1px solid #e8eaec;
    border-left: 1px solid #e8eaec;
  }

  .c-group-box {
    position: relative;
    background-color: #fff;
    min-height: 332px;

    .c-header {
      padding: 0 8px;
      height: 34px;
      font-size: 14px;
      color: #333;
      border-bottom: 1px solid #e8eaec;
      background-color: #f8f8f8;
      position: relative;

      span {
        line-height: 34px;
        vertical-align: middle;
      }

      span.tag-title {
        float: right;
        font-size: 12px;
        margin-right: 14px;
      }

      span.tag-icon {
        margin-right: 0;

        .ivu-icon {
          cursor: pointer;
        }
      }
    }

    .c-search {
      padding: 6px 8px;
    }

    .c-content {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      height: 253px;
      width: 100%;
      padding-bottom: 8px;

      .m-account {
        padding: 8px 8px;
        display: flex;

        &:hover {
          background-color: #f8f8f8;
        }

        &.active {
          color: #598fe6;
          background-color: #f8f8f8;

          .c-check-arrow {
            color: #598fe6 !important;
          }
        }
      }

      .c-item {
        width: 100%;
        position: relative;
        z-index: 5;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        span {
          width: calc(100% - 18px);
          line-height: 20px;
        }
      }

      .c-check-item {
        margin: 0;
        padding-left: 8px;
        display: flex;
        position: relative;
        align-items: center;
        height: 36px;
        width: 100%;

        &:hover {
          background-color: #f8f8f8;
        }

        .m-span {
          width: calc(100% - 186px);
          display: inline-block;
        }

        .item-type {
          text-align: right;
          display: inline-block;
          width: 60px;
          padding-right: 10px;
        }

        .ivu-radio-group {
          width: 70px !important;
        }

        .ivu-radio-wrapper {
          min-width: inherit;
          text-align: right;
          font-size: 0;
          margin-right: 14px;
        }

        .m-cataract {
          position: absolute;
          width: 18px;
          height: 36px;
          cursor: pointer;
          user-select: none;
          top: 0;
          z-index: 2;

          &.c-disabled {
            cursor: not-allowed;
          }
        }

        .c-include {
          right: 50px;
        }

        .c-exclude {
          right: 18px;
        }
      }
    }
  }

  .c-result-box {
    position: relative;

    ::v-deep .ivu-tabs-bar {
      background-color: #f8f8f8;
    }

    .c-retarget-clear {
      width: 60px;
      height: 34px;
      line-height: 34px;
      position: absolute;
      z-index: 8;
      right: 0;
      top: 0;
      display: block;
      color: #598fe6;
      text-align: center;
      cursor: pointer;
    }

    .c-retarget-result {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      height: 297px;
      padding-bottom: 8px;
      background-color: #fff;

      .c-tag-item {
        margin: 8px 12px 0;
        padding: 2px 6px;
        display: block;
        height: 28px;
      }
    }
  }
}
</style>
